import DialogCloseButton from '@cobliteam/colib-ui/Button';
import { Dialog, DialogBody, DialogClose, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@cobliteam/colib-ui/Dialog';
import DialogCloseIcon from '@cobliteam/colib-ui/Icon';
import { useUser } from '@cobliteam/hooks';
import { useTranslation } from '@cobliteam/i18n';
import i18nConfig from '@cobliteam/i18n/src/config/i18next.config';
import { lazy } from '@cobliteam/lazy-with-retries';
import TooltipOnIntent from '@cobliteam/ui-business/components/TooltipOnIntent/TooltipOnIntent';
import { Suspense } from 'react';

// Typeform (~58 KB) só é baixado quando o dialog abre: o conteúdo do Dialog não monta fechado.
const FeedbackTypeformWidget = lazy(() => import('./FeedbackTypeformWidget'));
interface FeedbackProps {
  showTooltip?: boolean;
  source?: string;
  children?: React.ReactNode;
}
const Feedback = ({ source = 'navbar', showTooltip = true, children }: FeedbackProps) => {
  const { t } = useTranslation('app-header');
  const { user, session, hasNoValidGroups } = useUser();
  if (hasNoValidGroups) return null;
  return (
    <Dialog>
      <DialogTrigger
        render={
          <div>
            <TooltipOnIntent render={<div>{children}</div>} disabled={!showTooltip}>
              {t('feedback.button')}
            </TooltipOnIntent>
          </div>
        }
        nativeButton={false}
        // The supplied child owns the button semantics; keep this ancestor stable while the tooltip loads.
        role={undefined}
        tabIndex={undefined}
      />
      <DialogContent size='lg' showCloseButton={false}>
        <DialogHeader className='flex-row items-center justify-between'>
          <DialogTitle>{t('feedback.title')}</DialogTitle>
          <DialogDescription className='sr-only' />
          <DialogClose
            aria-label={i18nConfig.t('common:buttons.close')}
            data-testid={'dialog-close'}
            render={
              <DialogCloseButton variant='ghost' size='icon-sm'>
                <DialogCloseIcon name='x' size='sm' />
              </DialogCloseButton>
            }
          />
        </DialogHeader>
        <DialogBody>
          <Suspense fallback={<div className='h-[600px]' />}>
            <FeedbackTypeformWidget
              hidden={{
                email: user?.email || '',
                user_id: user?.id || '',
                name: user?.name || '',
                url: window.location.href || '',
                source,
                fleet_id: session?.fleet.id || '',
                fleet_name: session?.fleet.name || '',
              }}
            />
          </Suspense>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};
export default Feedback;
